import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import apiClient from '../../Api/axiosConfig';

const Logout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    apiClient.post('/auth/logout')
      .then(() => {
        logout();
        navigate('/');
      })
      .catch(error => {
        console.error("Hiba a kijelentkezés során:", error);
        logout();
        navigate('/');
      });
  }, [logout, navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      Kijelentkezés...
    </div>
  );
};

export default Logout;